import React from "react";
import TicketListPage from "./TicketListPage";

const CustomerSupport = () => <TicketListPage partyType="Customer" title="Customer Support" accentColor="#2563eb" />;

export default CustomerSupport;
